import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { Calendar } from "@/components/Calendar/Calendar";
import { useEffect, useMemo, useState } from "react";
import { ar, enUS } from "react-day-picker/locale";
import { useTranslation } from "@i18n";
import { format, getUnixTime } from "date-fns";
import { arSA } from "date-fns/locale/ar-SA";
import { twMerge } from "tailwind-merge";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import useIsMobile from "@hooks/useIsMobile";
import { submitDateTime, getReschedule, getRescheduleTimes } from "@/apis/sell-my-car";
import { toast } from "sonner";
import FlowButton from "@/pages/sell-my-car/components/FlowButton";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { useLang } from "@/common/Contexts/LanguageContext";
var RescheduleAppointment = function RescheduleAppointment(_ref) {
  var requestId = _ref.requestId,
    onSuccess = _ref.onSuccess,
    onCancel = _ref.onCancel;
  var _useState = useState(undefined),
    date = _useState[0],
    setDate = _useState[1];
  var _useState2 = useState(true),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    isSubmitting = _useState3[0],
    setIsSubmitting = _useState3[1];
  var _useState4 = useState(false),
    isLoadingTimes = _useState4[0],
    setIsLoadingTimes = _useState4[1];
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState5 = useState(null),
    selectedTime = _useState5[0],
    setSelectedTime = _useState5[1];
  var isMobile = useIsMobile();
  var _useState6 = useState([]),
    availableDays = _useState6[0],
    setAvailableDays = _useState6[1];
  var _useState7 = useState([]),
    availableTimes = _useState7[0],
    setAvailableTimes = _useState7[1];
  var lang = useLang();

  // Fetch reschedule data on mount
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _response$data, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              setIsLoading(true);
              _context.p = 1;
              _context.n = 2;
              return getReschedule({
                request_id: requestId
              });
            case 2:
              response = _context.v;
              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.data) {
                setAvailableDays(response.data.data.available_days || []);
                setAvailableTimes(response.data.data.available_times || []);
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("Error fetching reschedule data:", _t);
              toast.error("حدث خطأ أثناء تحميل البيانات");
            case 4:
              _context.p = 4;
              setIsLoading(false);
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchData();
  }, [requestId]);

  // Convert available_days to Date objects for easier comparison
  var availableDates = useMemo(function () {
    if (!availableDays) return [];
    return availableDays.map(function (day) {
      // Parse date_value (format: "2025-12-30")
      var _day$date_value$split = day.date_value.split('-').map(Number),
        _day$date_value$split2 = _slicedToArray(_day$date_value$split, 3),
        year = _day$date_value$split2[0],
        month = _day$date_value$split2[1],
        dayNum = _day$date_value$split2[2];
      return new Date(year, month - 1, dayNum);
    });
  }, [availableDays]);

  // Create disabled matcher - disable past dates and unavailable dates
  var disabledMatcher = useMemo(function () {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return [
    // Disable dates before today
    {
      before: today
    },
    // Disable dates not in available_days
    function (day) {
      var isAvailable = availableDates.some(function (availableDate) {
        return availableDate.getFullYear() === day.getFullYear() && availableDate.getMonth() === day.getMonth() && availableDate.getDate() === day.getDate();
      });
      return !isAvailable;
    }];
  }, [availableDates]);

  // Get the start month (current month)
  var startMonth = useMemo(function () {
    var today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
  }, []);

  // Get the end month (6 months from the last available date)
  var endMonth = useMemo(function () {
    if (availableDates.length === 0) {
      // Default to 3 months from now if no available dates
      var future = new Date();
      future.setMonth(future.getMonth() + 2);
      return future;
    }

    // Find the maximum date from available dates
    var maxDate = availableDates.reduce(function (max, current) {
      return current > max ? current : max;
    }, availableDates[0]);

    // Add 2 months buffer
    var futureDate = new Date(maxDate);
    futureDate.setMonth(futureDate.getMonth() + 2);
    return futureDate;
  }, [availableDates]);
  var formatArabicTime = function formatArabicTime(timestamp) {
    // Convert Unix timestamp (seconds) to milliseconds and create Date object
    var date = new Date(timestamp * 1000);

    // Format using date-fns with Arabic locale
    var time = format(date, "hh:mm a", {
      locale: arSA
    });
    if (lang == 'ar') {
      return time.replace("ص", "صباحًا").replace("م", "مساءً");
    }
    return time.replace("ص", "AM").replace("م", "PM");
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
      var dateAtMidnight, datestamp, payload, response, timeDate, formattedDate, formattedTime, newAppointmentDate, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            e.preventDefault();
            if (!(!date || !selectedTime)) {
              _context2.n = 1;
              break;
            }
            toast.error("الرجاء اختيار التاريخ والوقت");
            return _context2.a(2);
          case 1:
            // Get datestamp (date at midnight)
            dateAtMidnight = new Date(date);
            dateAtMidnight.setHours(0, 0, 0, 0);
            datestamp = getUnixTime(dateAtMidnight);
            payload = {
              request_id: requestId,
              rescheduled_datestamp: datestamp,
              rescheduled_from_timestamp: selectedTime.from_timestamp,
              rescheduled_to_timestamp: selectedTime.to_timestamp,
              rescheduling_reason_id: 1,
              is_reschedule: 1
            };
            setIsSubmitting(true);
            _context2.p = 2;
            _context2.n = 3;
            return submitDateTime(payload);
          case 3:
            response = _context2.v;
            if (response) {
              toast.success("تم إعادة جدولة الموعد بنجاح");
              // Format new appointment date as "YYYY-MM-DD HH:mm:ss"
              timeDate = new Date(selectedTime.from_timestamp * 1000);
              formattedDate = format(date, "yyyy-MM-dd");
              formattedTime = format(timeDate, "HH:mm:ss");
              newAppointmentDate = "".concat(formattedDate, " ").concat(formattedTime);
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(newAppointmentDate);
            }
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            console.error("Error submitting date time:", _t2);
            toast.error("حدث خطأ أثناء إعادة جدولة الموعد");
          case 5:
            _context2.p = 5;
            setIsSubmitting(false);
            return _context2.f(5);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 4, 5, 6]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleDateSelect = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(selected) {
      var _response$data2, dayTimestamp, response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!selected) {
              _context3.n = 5;
              break;
            }
            setDate(selected);
            setIsLoadingTimes(true);
            _context3.p = 1;
            dayTimestamp = getUnixTime(selected);
            _context3.n = 2;
            return getRescheduleTimes({
              day: dayTimestamp,
              request_id: requestId
            });
          case 2:
            response = _context3.v;
            if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.data) {
              setAvailableTimes(response.data.data);
            }
            setSelectedTime(null);
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            console.error("Error fetching times:", _t3);
            toast.error("حدث خطأ أثناء تحميل الأوقات");
          case 4:
            _context3.p = 4;
            setIsLoadingTimes(false);
            return _context3.f(4);
          case 5:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3, 4, 5]]);
    }));
    return function handleDateSelect(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "py-6 px-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-2 px-4 border border-solid border-gray-echo rounded-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center h-64"
    }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null))));
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "py-6 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-2 px-4 border border-solid border-gray-echo rounded-lg"
  }, /*#__PURE__*/React.createElement(Calendar, {
    mode: "single",
    locale: lang == 'ar' ? ar : enUS,
    dir: lang == 'ar' ? 'rtl' : 'ltr',
    weekStartsOn: 0,
    className: "w-full p-0",
    selected: date,
    onSelect: handleDateSelect,
    buttonVariant: "ghost",
    disabled: disabledMatcher,
    today: new Date(),
    startMonth: startMonth,
    endMonth: endMonth
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between py-2 px-3 md:py-4 md:justify-between md:gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "w-3 h-3 rounded-full bg-[#12B0FF]"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] font-medium text-xs"
  }, tShort("sell_trade_v2/color_today", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "w-3 h-3 rounded-full bg-primary-new"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] font-medium text-xs"
  }, tShort("sell_trade_v2/color_available", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "w-3 h-3 rounded-full bg-[#B0B0B0]"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[#00143C] font-medium text-xs"
  }, tShort("sell_trade_v2/color_not_available", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-black-primary font-bold"
  }, tShort("sell_trade_v2/available_times", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 gap-3 md:grid-cols-4"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: isLoadingTimes
  }, /*#__PURE__*/React.createElement(Then, null, Array.from({
    length: isMobile ? 6 : 8
  }).map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "placeholder" + i,
      className: "rounded-lg p-2 border border-solid border-gray-echo text-center font-semibold text-base leading-6 bg-white animate-pulse cursor-default"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-4 w-full bg-gray-echo rounded"
    }));
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (availableTimes === null || availableTimes === void 0 ? void 0 : availableTimes.length) > 0
  }, /*#__PURE__*/React.createElement(Then, null, availableTimes.map(function (time) {
    return /*#__PURE__*/React.createElement("div", {
      key: time.from_timestamp,
      className: twMerge("rounded-lg p-2 border border-solid border-gray-echo text-center font-semibold text-base leading-6 text-black-primary cursor-pointer transition-colors", (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.from_timestamp) === time.from_timestamp && "text-primary-new border-primary-new bg-[#E7E7F8]", !time.is_active && "opacity-50 cursor-not-allowed"),
      onClick: function onClick() {
        if (time.is_active) {
          setSelectedTime(time);
        }
      }
    }, formatArabicTime(time.from_timestamp));
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    className: "col-span-3 text-center py-4 text-gray-500"
  }, "\u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645 \u0644\u0639\u0631\u0636 \u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629"))))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col absolute bottom-0 px-4 gap-2 pb-6 md:pb-0 w-full left-0 md:relative md:!mt-4 md:max-w-[340px] md:mx-auto md:gap-5"
  }, /*#__PURE__*/React.createElement(FlowButton, {
    type: "submit",
    disabled: isSubmitting || !date || !selectedTime || isLoadingTimes
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: isSubmitting || isLoadingTimes
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement(Else, null, tShort("sell_trade_v2/change_appointment", {
    ns: "web_sell_trade"
  })))))));
};
export default RescheduleAppointment;